import { render } from "./HotPointComponentSudden.vue?vue&type=template&id=404b0fa7&scoped=true"
import script from "./HotPointComponentSudden.vue?vue&type=script&lang=js"
export * from "./HotPointComponentSudden.vue?vue&type=script&lang=js"

import "./HotPointComponentSudden.vue?vue&type=style&index=0&id=404b0fa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404b0fa7"]])

export default __exports__